export default __webpack_public_path__ + "static/media/artboard1.ca0ff4f8.png";